import { render, staticRenderFns } from "./ConfigureRetrievalQuery.vue?vue&type=template&id=25dfbfcc&"
import script from "./ConfigureRetrievalQuery.vue?vue&type=script&lang=ts&"
export * from "./ConfigureRetrievalQuery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports